import { PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { handleHeaderItemClick } from '../../utils';

import { useTranslateFn } from '@shared/Translate';
import type { MenuItem } from '@shared-types/menu.types';

import * as styles from './styles.module.scss';

const CompetitionFeatured = ({ item }: { item: MenuItem }) => {
  const t = useTranslateFn();

  return (
    <div className={clsx('pk-rounded--l', styles.compFeature)}>
      <div className={styles.title}>{t('featuring-uefacom')}</div>

      <ul className='pk-d--flex pk-flex--wrap'>
        {item.menuItems.map((m) => (
          <li key={m.id} className='pk-py--xs'>
            <a
              href={m.href}
              target={m.target}
              aria-label={m.text}
              onClick={handleHeaderItemClick(m)}
              onAuxClick={handleHeaderItemClick(m)}
            >
              <PkIdentifier>
                <span slot='primary'>{m.text}</span>
              </PkIdentifier>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(CompetitionFeatured);
